import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import HeaderBox from "../../reuseableComponents/headerBox/HeaderBox";
import CommWaterSysPopChart from "./CommWaterSysPopChart";
import PopSerevedBywaterSysRatingChart from "./PopServedByWaterSysRatingChart";
import WaterSourceNoLocationDataChart from "./WaterSourceNoLocationDataChart";
import SysSizePopChart from "./SysSizePopChart";
import ActiveSysTypeChart from "./ActiveSysTypeChart";
import WtrSysByRating from "./WtrSysByRating";

const WsStatsPage = () => {
  return (
    <div className='page-container ws-stats-page-container'>
      <Row>
        <Col>
          <Link to='/' className='m-2 hyperlink' cypressid='home-page'>
            Home
          </Link>
          <span className='m-2 hyperlink'>|</span>
          <Link to='/secure/state-wide-reports' className='m-2' cypressid='state-wide-reports'>
            State Wide Reports
          </Link>
        </Col>
      </Row>
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"} cypressid='wsStatsPage'>
            <h3 style={{ color: "#fff" }}>Water System Statistics</h3>
          </HeaderBox>
        </Col>
      </Row>
      <Row>
        <Col>
          <SysSizePopChart />
        </Col>
        <Col>
          <CommWaterSysPopChart />
        </Col>
      </Row>
      <Row className='mb-5'>
        <Col>
          <WtrSysByRating />
        </Col>
        <Col>
          <ActiveSysTypeChart />
        </Col>
      </Row>
      <Row>
        <Col>
          <PopSerevedBywaterSysRatingChart />
        </Col>
        <Col>
          <WaterSourceNoLocationDataChart />
        </Col>
      </Row>
    </div>
  );
};
export default WsStatsPage;
